import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VendorServiceModule } from './v1/vendor.service';

@NgModule({
  imports: [CommonModule],
  exports: [VendorServiceModule],
})
export class MarketplaceAppsModule {}
